import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { keycloak } from './keycloak';

export interface CurrentUser {
  username?: string;
  fullName?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  roles: string[];
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private _user$ = new BehaviorSubject<CurrentUser | null>(null);
  user$ = this._user$.asObservable();

  constructor() {
    this.refreshUser();
  }

  refreshUser(): void {
    const parsed: any = keycloak.tokenParsed ?? null;

    if (!keycloak.authenticated || !parsed) {
      this._user$.next(null);
      return;
    }

    const roles = (parsed?.realm_access?.roles ?? []) as string[];

    this._user$.next({
      username: parsed.preferred_username,
      fullName: parsed.name,
      firstName: parsed.given_name,
      lastName: parsed.family_name,
      email: parsed.email,
      roles: roles.map((r) => String(r).toLowerCase()),
    });
  }

  isLoggedIn(): boolean {
    return !!keycloak.authenticated;
  }

  getToken(): string {
    return keycloak.token ?? '';
  }

  getUserRoles(): string[] {
    const parsed: any = keycloak.tokenParsed ?? {};
    const roles = (parsed?.realm_access?.roles ?? []) as string[];
    return roles.map((r) => String(r).toLowerCase());
  }

  hasRole(role: string): boolean {
    return keycloak.hasRealmRole(role);
  }

  // برای جاهایی که "یک نقش" می‌خواهند (مثل بعضی منوها)
  getUserRole(): string {
    const roles = this.getUserRoles();
    const order = ['admin', 'manager', 'expert', 'user', 'it', 'employee'];
    return order.find((r) => roles.includes(r)) ?? (roles[0] ?? '');
  }

  logout(): void {
    keycloak.logout({ redirectUri: window.location.origin });
  }
}
